import * as s from '../Table.css'

/** Icons that may replace header text in the table (not in the Columns menu). */
export type TableHeaderIconName = 'user' | 'wifi'

const ICON_SIZE = 14

function UserIcon({ size }: { size: number }) {
  const p = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  return (
    <svg {...p} aria-hidden>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  )
}

function WifiIcon({ size }: { size: number }) {
  const p = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  return (
    <svg {...p} aria-hidden>
      <path d="M5 12.55a11 11 0 0114.08 0" />
      <path d="M1.42 9a16 16 0 0121.16 0" />
      <path d="M8.53 16.11a6 6 0 016.95 0" />
      <circle cx="12" cy="20" r="1" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function TableHeaderIcon({
  name,
  label,
  size = ICON_SIZE,
}: {
  name: TableHeaderIconName
  /** Accessible name (Columns menu uses this as the text label). */
  label: string
  size?: number
}) {
  return (
    <span className={s.thHeaderIcon} title={label} aria-label={label}>
      {name === 'user' ? <UserIcon size={size} /> : null}
      {name === 'wifi' ? <WifiIcon size={size} /> : null}
    </span>
  )
}
